@let isDisabled = disabled();

<div
  ngpToggleGroup
  [attr.data-readonly]="isReadonly() || null"
  [ngpToggleGroupValue]="selectedValues()"
  [ngpToggleGroupDisabled]="isDisabled"
  [ngpToggleGroupOrientation]="orientation()"
  [ngpToggleGroupAllowDeselection]="false"
  [class]="groupClass()"
  (ngpToggleGroupValueChange)="onValueChange($event)"
>
  @if (rect(); as rect) {
    <span
      [class]="slidingRectClass"
      [style.top.px]="rect.top"
      [style.left.px]="rect.left"
      [style.width.px]="rect.width"
      [style.height.px]="rect.height"
      aria-hidden="true"
    ></span>
  }

  @for (opt of options(); track opt.value) {
    <button
      #item
      ngpToggleGroupItem
      type="button"
      [ngpToggleGroupItemValue]="opt.value"
      [ngpToggleGroupItemDisabled]="isDisabled || (opt.disabled ?? false)"
      [class]="itemClass()"
    >
      @if (opt.icon; as icon) {
        <ml-icon [name]="icon" size="lg" aria-hidden="true" />
      }
      <span class="inline-flex items-center gap-1">
        {{ opt.label | mlTranslate }}
        @if (opt.error) {
          <span class="bg-error-500 size-2 rounded-full" aria-hidden="true"></span>
        }
      </span>
    </button>
  }
</div>
